export default {
  duration: {
    // complex: 4000,
    long: 600,
  },
};
